// extracted by mini-css-extract-plugin
export default {"title":"GraphicsControls_title__RuOWQ","gradient":"GraphicsControls_gradient__HQdPY","graphicsContainer":"GraphicsControls_graphicsContainer__WFX4I"};